export const HEADING_COLOR = "#95b7c0" 
export const SHADOW_COLOR = "#95b7c0"
export const HEADER_ICON_COLOR = "white"
export const BUTTON_STYLE:any = {
    textTransform: 'none',
  background: "#95b7c0",
  boxShadow: "rgb(212 205 204) 0px 0px 7px 3px",
  color:"white",
  ":hover":{
   color:"black"
  }
}

export const BUTTON_STYLE2:any = {
  textTransform: 'none',
boxShadow: "rgb(212 205 204) 0px 0px 7px 3px",
color:"white",
":hover":{
 color:"white"
},
marginLeft:"10px"

}
export const CANCEL_BUTTON_STYLE:any = {
  textTransform: 'none',
background: "#bab6b6",
boxShadow: "rgb(212 205 204) 0px 0px 7px 3px",
color:"white",
":hover":{
   color:"black"
  }
}


